import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { Outlet } from 'react-router-dom'
import { EstPianoMantenimentoRoute } from '@/routes/admin/software/pages/EstPianoMantenimento.route'
import { EstStatoNoleggioRoute } from '@/routes/admin/software/pages/EstStatoNoleggio.route'
import { EstSoftwareRoute } from '@/routes/admin/software/pages/EstSoftware.route'
import { QSApplicationRoute } from '@/routes/admin/software/pages/QSApplication.route'
import { QSVersionRoute } from '@/routes/admin/software/pages/QSVersion.route'

export const SoftwareRoute: TileRoleRoute = {
  path: 'softwaremanagement',
  text: 'Software',
  element: (
    <>
      <Outlet />
    </>
  ),
  mainMenuRoute: false,
  allowedRoles: [Roles.GlobalAdministrator],
  tile: true,
  children: [EstPianoMantenimentoRoute, EstStatoNoleggioRoute, EstSoftwareRoute, QSApplicationRoute, QSVersionRoute],
}
